var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"go-top",class:{show: _vm.showGoTop},on:{"click":_vm.goTop}},[_c('img',{attrs:{"src":"https://site-cdn.huami.com/files/amazfit/mobile/assets/go-top.png","alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }